import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOffers } from "../../constants";
import { ISectionStyle } from "./getSectionStyle.types";

export const requestGetSectionStyle = async (): Promise<ISectionStyle> => {
  return await instance.get(
    buildUrl(ApiRoutesOffers.SpecialOffers, ApiRoutesOffers.SectionStyle)
  );
};
